module.exports = __webpack_public_path__ + "img/device-verify.8d74c663.png";